import React from 'react'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import InternationalImage from './InternationalImage'
import InternationalText from './InternationalText'
import InternationalCard from './InternationalCard'

const International = () => {
  return (
    <>
     <InternationalImage/>
     <InternationalText/>
     <InternationalCard/>
     <Scroll/>
     <Footer/>
      
    </>
  )
}

export default International
